//--
import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
 

import { RequestType } from "../../../types/enums/request-enums";
 //#region comment metod
 const GetProductStockDetail=(params:any)=>request({
  url: ApiURL.Query.getStockDetail,
  method: RequestType.GET,
  params:params
 });
 const GetProductDetail=(params:any)=>request({
  url: ApiURL.Query.getProductDetail+"?OptionId="+params.optionId+"&warehouseGroupId="+params.warehouseGroupId,
  method: RequestType.GET,
 });
 const GetProductDetailAll=(params:any)=>request({
  url: ApiURL.Query.getProductDetailAll+"?OptionId="+params,
  method: RequestType.GET,
 });

  const GetProductDetailWithProductId=(params:any)=> request({
  url: ApiURL.Query.getProductDetailWithProductId,
  method: RequestType.GET,
  params:params
 });
 const GetOptionIds=(data:any)=> request({
  url: ApiURL.Query.getOptionIds,
  method: RequestType.POST,
  data:data
 });
 const GetMultipleOptionId=(data:any)=> request({
  url: ApiURL.Query.getProductDetailWithMultipleOption,
  method: RequestType.POST,
  data:data
 });
 const GetCommentData=(data:any)=> request({
  url: ApiURL.Query.GetCommentData+"?ColorCode="+data.colorCode+"&SpecialCode="+data.specialCode+"&Page="+data.page+"&Size="+data.size+"&approveStatus="+data.approveStatus+"&GrievanceStatus=2",
  method: RequestType.GET,
 });
 const GetCommentDataV2=(data:any)=> request({
  url: ApiURL.Query.GetCommentDataV2+"?ColorCode="+data.colorCode+"&SpecialCode="+data.specialCode+"&Page="+data.page+"&Size="+data.size+"&approveStatus="+data.approveStatus+"&GrievanceStatus=2",
  method: RequestType.GET,
 });
 const GetProductSizeMeasurements=(params:any)=> request({
  url: ApiURL.Query.getProductSizeMeasurements,
  method: RequestType.GET,
  params: params
 });
 
const ProductSearchServiceQuery = {
  GetProductStockDetail,
  GetProductDetail,
  GetProductDetailAll,
  GetProductDetailWithProductId,
  GetOptionIds,
  GetCommentData,
  GetMultipleOptionId,
  GetCommentDataV2,
  GetProductSizeMeasurements
};

export default ProductSearchServiceQuery;
